import {
    __, all, compose, filter, forEachObjIndexed, isEmpty, keys, map, pluck, propOr,
    reject, without, values,
} from 'ramda'
import { ArrayOf, isModel, OneOf, Optional, toObjectModel } from './model'


// validateTranslation :: Obj -> Boolean
export const validateTranslation = isModel({
    pages: {
        intro: {
            headline: String,
            intro: String,
            newCookie: String,
            acceptAll: String,
            settings: String,
            acceptTechnicallyRequired: String,
        },
        settings: {
            headline: String,
            intro: String,
            technicallyRequired: {
                headline: String,
                subheadline: String,
                intro: String,
            },
            acceptAll: String,
            acceptSelected: String,
            acceptTechnicallyRequired: String,
            closeButton: String,
        },
        glossary: {
            headline: String,
            backButton: String,
            closeButton: String,
            definitions: Array,
        },
    },
    links: {
        dataPrivacy: {
            linkText: String,
            title: String,
            link: String,
        },
        imprint: {
            linkText: String,
            title: String,
            link: String,
        },
    },
    cookies: Object,
})

// checkIfAllCookiesHaveTranslations :: Obj -> Boolean
export const checkIfAllCookiesHaveTranslations = (cookieConfig) => {
    const availableIds = pluck('id', cookieConfig.cookies)

    return compose(
        all(isEmpty),
        values,
        forEachObjIndexed((value, locale) => {
            console.error(`Defintions for locale '${locale}' are incomplete or missing for the follwing ids: '${value.join(', ')}'!`)
        }),
        reject(isEmpty),
        map(compose(
            without(__, availableIds),
            keys,
            filter(isModel({
                title: String,
                sections: ArrayOf({
                    label: String,
                    value: String,
                }),
            })),
            propOr({}, 'cookies'),
        )),
    )(cookieConfig.translations)
}

// validateCookieConfig :: Obj -> Boolean
export const validateCookieConfig = isModel(toObjectModel({
    translations: Object,
    fallbackLocale: String,
    hideOnPaths: Optional(ArrayOf(String)),
    consentCookie: {
        name: String,
        expiresAfterDays: OneOf(String, Number),
        sameSite: String,
        domain: Optional(String),
    },
    domains: ArrayOf(String),
    paths: ArrayOf(String),
    cookies: ArrayOf({
        id: String,
        technicallyRequired: Boolean,
        cookies: ArrayOf({
            name: OneOf(String, RegExp),
            path: Optional(String),
            domain: Optional(String),
        }),
        requires: Optional(Array),
        onAccepted: Optional(Function),
    }),
}, [
    [
        ({ translations = {} }) => !isEmpty(translations),
        'There are no translations specified.',
    ],
    [
        ({ translations = {} }) => values(translations).every(validateTranslation),
        'Translation is not valid',
    ],
    [

        checkIfAllCookiesHaveTranslations,
        'There are cookies without translations',
    ],
]))
